<template>
  <SanityVideo class="NonInteractiveVideo"
    autoplay loop muted playsinline
    v-bind="props"
  />
</template>

<script setup>
const props = defineProps({
  posterImage: {
    type: Object,
    default: null,
  },
  videoFile: {
    type: Object,
    default: null,
  },
})
</script>
